module.exports = __webpack_public_path__ + "img/filter.c7664ba2.svg";